import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { EmployeeType } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteEmployeeType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("employee-types", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Employee Type Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.EMPLOYEE_TYPES,
        (employeeTypes: EmployeeType[] | undefined) => {
          return !employeeTypes
            ? []
            : deleteEntity<EmployeeType>(employeeTypes, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Employee Type Deleting Error", { variant: "error" });
    },
  });
};
